module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "center",
    attrs: {
      "id": "praise"
    }
  }, [_vm._v("PRAISE FOR THE WRITING OF PAT MURPHY")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('b', [_c('i', [_vm._v("The Falling Woman")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Winner of the Nebula Award for Best Novel")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“A lovely and literate exploration of the dark moment where myth and science meet.” —Samuel R. Delany")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“Murphy’s sharp behavioral observation, her rich Mayan background, and the revolving door of fantasy and reality honorably recall the novels of Margaret Atwood.” —"), _c('i', [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“Murphy’s convincing modern setting is a marvelous foil for her frighteningly alien Mayan ghost, and the archeological material, besides being fascinating in its own right, is put to excellent use in the plot.” —"), _c('i', [_vm._v("Newsday")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b', [_c('i', [_vm._v("The City, Not Long After")])])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“A grand adventure.” —"), _c('i', [_vm._v("San Francisco Chronicle")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“In Ms. Murphy’s skillful hands, the showdown between art and power takes on mythic dimensions… . No one comes out of this confrontation unchanged, including the reader.” —"), _c('i', [_vm._v("The New York Times Book Review")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b', [_c('i', [_vm._v("Points of Departure")])])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“There is something of Borges’s absurdist fables and of the fey, fog-haunted feel of Celtic myth to ["), _c('i', [_vm._v("Points of Departure")]), _vm._v("]. This collection reverberates with the sound of the author’s unmistakable voice, a poetic blend of the everyday and the never-never.” —"), _c('i', [_vm._v("Elle")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“Brilliant, passionate, and dangerous as only the clearest visions can be … Murphy creates seamless blends of ideas and emotions, holistic works where genres mingle so the reader does not stop to ask if this is sf, fantasy, or horror… . These tales unite the power of a force of nature with the subtlety of the human heart.” —"), _c('i', [_vm._v("Locus")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b', [_c('i', [_vm._v("Wild Angel")])])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“A charming adventure.” —"), _c('i', [_vm._v("The Denver Post")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“A delightful cross-genre mix with elements of mystery, western and fantasy/adventure infused with a feminist sensibility.” —Rambles.net")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“Faithful to the spirit of Edgar Rice Burrough’s Tarzan tales and Rudyard Kipling’s "), _c('i', [_vm._v("Jungle Book")]), _vm._v(", this [is the] story of a young girl’s courage and resourcefulness.” —"), _c('i', [_vm._v("Library Journal")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b', [_c('i', [_vm._v("Adventures in Time and Space with Max Merriwell")])])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“Set on a cruise ship that blithely steams through the Bermuda Triangle, this savvy romp buttresses its nonstop action with quantum-mechanical insights into the nature of the universe and postmodern noodling about the nature of writing and reading.” —"), _c('i', [_vm._v("The New York Times Book Review")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“This cerebral equivalent of a roller-coaster ride … is replete with absorbing ponderings on the nature of reality and the nature of the novel… . The questions of who is in charge, who is real and whether the answers to those questions matter will leave readers pleasantly dizzy.” —"), _c('i', [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“A paean to the potentialities of imagination, foaming quantum uncertainties, and the sheer plasticity of human reality.” —"), _c('i', [_vm._v("Analog Science Fiction and Fact")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b', [_c('i', [_vm._v("The Shadow Hunter")])])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“The clash of prehistoric shamanic traditions with future technology makes for a gripping tale—the first novel written by this Nebula Award-winning author.” —"), _c('i', [_vm._v("Publishers Weekly")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc5853a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/2praise.vue
// module id = 63
// module chunks = 0